<div class="widget-content" [ngClass]="widgetClass">
  <div class="header-container">
    <h1 class="title">{{ title }}</h1>
    <bpc-filter-dropdown [filters]="filters"
      (onChange)="filterChangeEvent($event)" />
  </div>
  
  <ng-content></ng-content>
</div>
